<template>
  <div :class="`hover-item ${customClass}`">
    <div class="arrow-up"></div>
    <a
      v-if="item.quantity > 0"
      href="javascript:;"
      @click="addToCart(item)"
      class="btn btn-primary add-to-cart btn-sm"
      >
      <span v-if="item.sale_type === 'Regular'"> Add to Cart</span>
      <span v-else> Pre Order</span>
      </a
    >

    <ReprintRequest v-else :item="item"/>

    <a
      :href="`${baseUrl}book/${item.id}`"
      class="btn btn-black view-details btn-sm"
      >View Details</a
    >
  </div>
</template>
<script>
import ReprintRequest from './ReprintRequest.vue';

export default {
  props: ["item", "customClass"],
  components: {
    ReprintRequest
  },
  methods: {
    addToCart(row) {
      let itemObj = {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        image: row.image,
        price: row.price,
        quantity: 1,
        name: row.product_name,
        sale_type: row.sale_type
      };
      // Call saveToCart and get the status and message
      const result = this.$helper.saveToCart(itemObj);

      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);

      if (result.status === 'success') {
        this.flashMessage.success({ message: result.message });
      } else if (result.status === 'error') {
          this.flashMessage.error({ message: result.message });
      }

    }
  },
};
</script>
